// React
import React, { memo, useRef } from "react";
// Custom
import { InputNumber } from "components";
import { Field } from "..";
// Resources
import inputStyles from "../Input/Input.module.scss";

export const InputNumberRange = ({ from, to }: InputNumberRangeProps): JSX.Element => {
  const toRef = useRef(null);

  const toProps = {
    ...to,
    innerRef: toRef,
    min: from.value,
  };

  return (
    <div className={inputStyles.range}>
      <InputNumber {...from} />
      <span className={inputStyles.input__spacer}>to</span>
      <InputNumber {...toProps} />
    </div>
  );
};
InputNumberRange.displayName = "InputNumberRange";

export const FieldNumberRange = memo<FieldNumberRangeProps>(
  ({
    errors: { from: errorFrom, to: errorTo } = { from: false, to: false },
    inputProps,
    ...props
  }: FieldNumberRangeProps): JSX.Element => {
    let message = "";
    if (errorFrom) {
      message = errorFrom;
    }
    if (errorTo) {
      message = message ? `${message} ${errorTo}` : errorTo;
    }

    return (
      <Field error={message} labelFor={inputProps.from.name} {...props}>
        <InputNumberRange
          from={{
            ...inputProps.from,
            hasError: !!errorFrom,
          }}
          to={{
            ...inputProps.to,
            hasError: !!errorTo,
          }}
        />
      </Field>
    );
  },
);
FieldNumberRange.displayName = "FieldNumberRange";
